export default function PrivacyPolicy() {
  return (
    <section className="as-section">
      <div className="container">
        <h1 className="as-page-title">Privacy Policy</h1>

        <h2 className="as-subheading">Who we are</h2>
        <p>Our website address is: https://allships.com.au</p>

        <h2 className="as-subheading">Comments</h2>
        <p>
          The Allships site provides marine master training tools including marine
          module exercises and self-testing tools for the purpose of supporting your
          journey through getting Master and Coxswain certification.
        </p>

        <h2 className="as-subheading">Media</h2>
        <p>
          If you upload images to the website, you should avoid uploading images with
          embedded location data (EXIF GPS) included. Visitors to the website can
          download and extract any location data from images on the website.
        </p>

        <h2 className="as-subheading">Embedded content from other websites</h2>
        <p>
          Articles on this site may include embedded content (e.g. videos, images,
          articles, etc.). Embedded content from other websites behaves in the exact
          same way as if the visitor has visited the other website.
        </p>
        <p>
          These websites may collect data about you, use cookies, embed additional
          third-party tracking, and monitor your interaction with that embedded content,
          including tracking your interaction with the embedded content if you have an
          account and are logged in to that website.
        </p>

        <h2 className="as-subheading">Who we share your data with</h2>
        <p>
          Allships.com.au does not collect or store any user information and does not
          pass any personal information to any third party for marketing or other
          purposes.
        </p>
      </div>
    </section>
  );
}
